<template>
  <div class="row">
    <div class="col-md-12">
      <div class="card">
        <div class="card-body">
          <b-tabs v-model="tabIndex">
            <b-tab title="الكونكت">
              <data-table :edit-item="editItem" />
            </b-tab>
            <b-tab @click="newItem= {}" :title="$t('site.add')">
              <my-form :new-item="newItem" />
            </b-tab>
          </b-tabs>
        </div>
        <!-- end of card body -->
      </div>
      <!-- end of card -->
    </div>
    <!-- end of col -->
  </div>
</template>

<script>
import Auth from "@/Apis/Auth";
import DataTableVue from "./components/DataTable.vue";
import FormVue from "./components/Form.vue";

export default {
  name: "CountriesIndex",
  components: {
    "data-table": DataTableVue,
    "my-form": FormVue,
  },
  data() {
    return {
      newItem: {},
      tabIndex: 0,
    };
  },
  created() {},
  methods: {
    editItem(data) {
      this.tabIndex = 1;
      this.newItem = data.item;
    },
  },
};
</script>
